import { useEffect, useState } from 'react';
import api from '../api/api';
import usePageSeo from './usePageSeo';

const SITE_URL = 'https://poppyruz.com';

function buildDescription(bookName, description) {
  if (description && description.trim()) {
    const trimmed = description.trim();
    return trimmed.length > 160 ? `${trimmed.slice(0, 157)}...` : trimmed;
  }
  return `Read ${bookName} online on Poppyruz.`;
}

export default function useBookSeo(bookId) {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    if (!bookId) return undefined;

    let cancelled = false;

    const load = async () => {
      try {
        const { data } = await api.get(`/api/v1/pdf_parser/seo/books/${bookId}/`);
        if (!cancelled) {
          setSeo(data);
        }
      } catch {
        if (!cancelled) {
          setSeo(null);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [bookId]);

  const bookName = seo?.book_name || 'Book';
  const path = seo?.read_path || `/read_book/${bookId}`;
  const description = buildDescription(bookName, seo?.description);
  const pageUrl = `${SITE_URL}${path}`;

  const jsonLd = seo
    ? {
        '@context': 'https://schema.org',
        '@type': 'Book',
        name: seo.book_name,
        description,
        url: pageUrl,
        ...(seo.book_cover ? { image: seo.book_cover } : {}),
        publisher: {
          '@type': 'Organization',
          name: 'Poppyruz',
          url: SITE_URL,
        },
      }
    : null;

  usePageSeo({
    title: bookName,
    description,
    path,
    image: seo?.book_cover || undefined,
    jsonLd,
  });
}
